import { Action } from "@ngrx/store";
import { MetricVisibilities } from "./state";

export const GET_METRICS = "GET_METRICS";
export const GET_METRICS_SUCCESS = "GET_METRICS_SUCCESS";
export const GET_METRICS_ERROR = "GET_METRICS_ERROR";
export const SELECT_METRIC = "SELECT_METRIC";
export const UPDATE_METRIC_NAME = "UPDATE_METRIC_NAME";
export const UPDATE_METRIC_DESC = "UPDATE_METRIC_DESC";
export const UPDATE_METRIC_VISIBILITY = "UPDATE_METRIC_VISIBILITY";
export const SAVE_METRIC_TITLE_DESC = "SAVE_METRIC_TITLE_DESC";
export const SAVE_METRIC_TITLE_DESC_SUCCESS = "SAVE_METRIC_TITLE_DESC_SUCCESS";
export const SAVE_METRIC_TITLE_DESC_ERROR = "SAVE_METRIC_TITLE_DESC_ERROR";
export const GET_SELECTED_METRIC_DATA = "GET_SELECTED_METRIC_DATA";
export const GET_SELECTED_METRIC_DATA_SUCCESS =
  "GET_SELECTED_METRIC_DATA_SUCCESS";
export const GET_SELECTED_METRIC_DATA_ERROR = "GET_SELECTED_METRIC_DATA_ERROR";
export const UPDATE_METRIC_VISIBILITY_SUCCESS =
  "UPDATE_METRIC_VISIBILITY_SUCCESS";
export const UPDATE_METRIC_VISIBILITY_ERROR = "UPDATE_METRIC_VISIBILITY_ERROR";
export const UPDATE_OTHER_REPORTS_URL = "UPDATE_OTHER_REPORTS_URL";
export const SAVE_OTHER_REPORTS_URL = "SAVE_OTHER_REPORTS_URL";
export const SAVE_OTHER_REPORTS_URL_SUCCESS = "SAVE_OTHER_REPORTS_URL_SUCCESS";
export const SAVE_OTHER_REPORTS_URL_ERROR = "SAVE_OTHER_REPORTS_URL_ERROR";
export const RESET_SAVED_SUCCESS_MESSAGE = "RESET_SAVED_SUCCESS_MESSAGE";

export class GetMetricsAction implements Action {
  readonly type = GET_METRICS;

  constructor(public payload: string) {}
}

export class GetSelectedMetricDataAction implements Action {
  readonly type = GET_SELECTED_METRIC_DATA;

  constructor(public payload: string) {}
}

export class SelectMetricAction implements Action {
  readonly type = SELECT_METRIC;

  constructor(public payload: string) {}
}

export class UpdateMetricNameAction implements Action {
  readonly type = UPDATE_METRIC_NAME;

  constructor(public payload: string) {}
}

export class UpdateMetricDescAction implements Action {
  readonly type = UPDATE_METRIC_DESC;

  constructor(public payload: string) {}
}

export class UpdateMetricVisibilityAction implements Action {
  readonly type = UPDATE_METRIC_VISIBILITY;

  constructor(public payload: Array<MetricVisibilities>) {}
}

export class UpdateotherReportsUrlAction implements Action {
  readonly type = UPDATE_OTHER_REPORTS_URL;

  constructor(public payload: string) {}
}

export class ResetSavedSuccessMessageAction implements Action {
  readonly type = RESET_SAVED_SUCCESS_MESSAGE;

  constructor(public payload: string) {}
}
